module.exports = __webpack_public_path__ + "media/application/images/placeholder/medium-8c42a32ae27e238256fda29ec9806c85.jpg";